import Header from "../../components/public/header";
import Navigation from "../../components/public/navigation";
import Main from "../../components/public/sections/main";
import Photos from "../../components/public/photos";
import Footer from "../../components/public/footer";

export default () => {
  return (
    <>
      <Navigation />
      <Header />
      <Main pageHeading={"फोटो गॅलरी"} content={<Photos />} />
      <Footer />
    </>
  );
};
